import { useCallback, useState } from 'react'

/**
 * Purchase-CTA state shared by the paywall banners. A successful purchase
 * only dismisses its banner once the billing refresh lands; the CTA must
 * stay held down through that window — the mutation has settled (isPending
 * drops) and its idempotency key rotates on success, so another click would
 * start a second real charge. `settled` is that hold: OR it into the CTA's
 * pending flag.
 */
export function usePurchaseLatch() {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [settled, setSettled] = useState(false)

  /** Call as a purchase starts: clears the previous attempt's error. */
  const begin = useCallback(() => setErrorMessage(null), [])
  /** Call when the purchase committed: holds the CTA until the banner unmounts. */
  const settle = useCallback(() => setSettled(true), [])
  const fail = useCallback((error: Error) => setErrorMessage(error.message), [])

  return { errorMessage, settled, begin, settle, fail }
}
